import { render, staticRenderFns } from "./tableReturn.vue?vue&type=template&id=1226794f&scoped=true"
import script from "./tableReturn.vue?vue&type=script&lang=js"
export * from "./tableReturn.vue?vue&type=script&lang=js"
import style0 from "./tableReturn.vue?vue&type=style&index=0&id=1226794f&prod&lang=css"
import style1 from "./tableReturn.vue?vue&type=style&index=1&id=1226794f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1226794f",
  null
  
)

export default component.exports